import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/apiError';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Server-side caches (KV-bumped) take care of cross-mutation freshness,
        // and explicit invalidations from mutations cover the rest. Keep data fresh
        // for 5 minutes by default to avoid refetching every component switch.
        staleTime: 5 * 60_000,
        gcTime: 10 * 60_000,
        // Window-focus refetch is opt-in per hook (e.g. notifications) — default off
        // so tab-switching does not fire 5–10 parallel /v1/me/* requests.
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (error instanceof ApiError) {
            if (error.status >= 400 && error.status < 500) return false;
          }
          return failureCount < 2;
        },
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
